import axios from 'axios'
import qs from "qs"
let base = '';
//通用方法


export const POST = (url, params) => {

  return axios.post(`${base}${url}`, params)
}

export const POST_PARAMS = (url, params) => {

  return axios.post(`${base}${url}`, qs.stringify(params))
}
export const GET = (url, params) => {
  return axios.get(`${base}${url}`, {params:params})
}

export const PUT = (url, params) => {
  return axios.put(`${base}${url}`, params)
}

export const DELETE = (url, params) => {
  return axios.delete(`${base}${url}`, {data:params})
}

export const PATCH = (url, params) => {
  return axios.patch(`${base}${url}`, params)
}

/**
* 主要用于文件上传
*/
export const POST_FORM = (url, form, requestConfig) => {
  if (!requestConfig){
    requestConfig = {};
  }
  if (!requestConfig.hasOwnProperty("headers")){
    requestConfig.headers = {
      'Content-Type': 'multipart/form-data'
    }
  }

  return axios.post(`${base}${url}`, form,requestConfig)
}

/**
* 主要用于文件上传
*/
export const PUT_FORM = (url, form) => {
	 let requestConfig = {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    }
  return axios.put(`${base}${url}`, form,requestConfig)
}


export const POST_DOWNLOAD = (url, param, requestConfig) => {
	 if (requestConfig){
	   if (!requestConfig.hasOwnProperty("headers")){
	     requestConfig.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
	     }
     }
	   if(!requestConfig.hasOwnProperty("responseType")){
	     requestConfig.responseType = "blob"
     }
   }
  return axios.post(`${base}${url}`, param, requestConfig)
}



// WEBPACK FOOTER //
// ./src/api/index.js